var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ckeditor',{class:{'ck_hide_toolbar': this.hidetoolbar || this.field.hidetoolbar, 'ck_transparent': this.transparent || this.field.transparent},attrs:{"editor":_vm.editor,"config":_vm.config,"disabled":_vm.disabled},on:{"input":_vm.onInput},model:{value:(_vm.editorData),callback:function ($$v) {_vm.editorData=$$v},expression:"editorData"}})
}
var staticRenderFns = []

export { render, staticRenderFns }